import useSingleOrganization from '../../../hooks/useSingleOrganization'
import NewCreateUserLinkModal from '../../../../createUserLink/components/NewCreateUserLink/NewCreateUserLinkModal/NewCreateUserLinkModal'
import AddNewCreateUserLinkButtonPresenter from '../../../../createUserLink/components/NewCreateUserLink/AddNewCreateUserLinkButton/AddNewCreateUserLinkButtonPresenter'

export default function AddNewCreateUserLinkFormModalOrga({modalId}: {modalId?: string}) {
   const { organizationId} = useSingleOrganization()

  return (
    <>
    <AddNewCreateUserLinkButtonPresenter modalId={modalId} />
    <NewCreateUserLinkModal modalId={modalId} organizationId={organizationId} />
    </>
  )
}
